import styles from './input-currency.module.css'

import { InputCurrencySizeEnum } from './input-currency.type'

export const sizes: Record<InputCurrencySizeEnum, string> = {
  small: styles['size-small'],
  medium: styles['size-medium'],
  large: styles['size-large'],
}

export const disabledClasses = {
  enabled: styles.enabled,
  disabled: styles.disabled,
}

export const generateClasses = (
  size: keyof typeof InputCurrencySizeEnum,
  error?: boolean,
  disabled?: boolean,
) => {
  return `${styles.container} ${sizes[size]} ${
    !error || styles['state-danger']
  } ${disabledClasses[disabled ? 'disabled' : 'enabled']}`
}
